import { useMemo } from 'react';
import { createAuthenticatedApiClient } from '../../../shared/api/apiClient';
import { rpcCall } from '../../../shared/api/rpcClient';
import { useAuth } from '../../auth/context/AuthContext';
import type { TicketView } from '../../../types/backend';

export interface TicketListFilters {
  updated_since?: string;
  page?: number;
  per_page?: number;
}

export const createTicketService = (idToken: string) => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    listTickets: async (customerId: string, filters?: TicketListFilters): Promise<TicketView[]> => {
      return rpcCall(client, 'itsm.ListTickets', {
        customer_id: customerId,
        ...filters,
      });
    },

    getTicket: async (customerId: string, ticketId: string): Promise<TicketView> => {
      return rpcCall(client, 'itsm.GetTicket', {
        customer_id: customerId,
        ticket_id: ticketId,
      });
    },

    addNote: async (customerId: string, ticketId: string, body: string): Promise<void> => {
      await rpcCall(client, 'itsm.AddTicketNote', {
        customer_id: customerId,
        ticket_id: ticketId,
        body,
      });
    },
  };
};

export const useTicketService = () => {
  const { idToken } = useAuth();

  return useMemo(() => {
    if (!idToken) {
      throw new Error('Not authenticated');
    }

    return createTicketService(idToken);
  }, [idToken]);
};
